import { event } from "@zillow/universal-analytics";
function triggerFormFieldEngagementClickstreamEvent(label) {
  event({
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "3",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_property_report_form",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: {
      block_type_cd: "form_field",
      block_id: "property_report",
      block_displayed_txt: label
    }
  });
}
function triggerFormSubmitClickstreamEvent(isValid, invalidFields, submitSuccess, serverResponseMessage) {
  event({
    envelope: {
      event_type_id: "2055",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_property_report_form",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_submit"
    },
    cms_info: {
      block_type_cd: "property_report_form",
      block_id: "property_report",
      form_form_is_valid_ind: isValid,
      form_invalid_fields_txt: invalidFields,
      form_submit_success_ind: submitSuccess,
      form_server_response_message_txt: ""
    }
  });
}
function triggerSubmitAnotherReportClickstreamEvent(buttonText, buttonUrl, target) {
  event({
    envelope: {
      event_type_id: "2048",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_property_report_form",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_click"
    },
    cms_info: {
      block_type_cd: "button",
      block_id: "property_report",
      block_displayed_txt: buttonText,
      block_target_url: buttonUrl,
      block_target_window_txt: target
    }
  });
}
function triggerPrivacyPolicyClickstreamEvent(linkText, linkUrl, target) {
  event({
    envelope: {
      event_type_id: "2048",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_property_report_form",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_click"
    },
    cms_info: {
      block_type_cd: "anchor",
      block_id: "property_report",
      block_displayed_txt: linkText,
      block_target_url: linkUrl,
      block_target_window_txt: target
    }
  });
}
export {
  triggerFormFieldEngagementClickstreamEvent,
  triggerFormSubmitClickstreamEvent,
  triggerPrivacyPolicyClickstreamEvent,
  triggerSubmitAnotherReportClickstreamEvent
};
